import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShellNavItem } from '../shell-nav.config';

@Component({
  selector: 'app-link-list',
  templateUrl: './link-list.component.html',
  styleUrls: ['./link-list.component.scss']
})
export class LinkListComponent {
  @Input() links: ShellNavItem[] = [];

  @Input() variant: 'topbar' | 'drawer' = 'topbar';

  @Input() orderTooltip = '';

  @Output() itemNavigate = new EventEmitter<void>();

  get visibleLinks() {
    return this.links.filter((link) => {
      if (this.variant === 'drawer') {
        return link.meta?.showInDrawer !== false;
      }

      return link.meta?.showInTopNav !== false;
    });
  }

  trackByPath(_: number, link: ShellNavItem) {
    return `${link.path}:${link.label}`;
  }

  handleNavigate() {
    this.itemNavigate.emit();
  }
}
